import { render, staticRenderFns } from "./SeatbeltUnbuckledIcon.vue?vue&type=template&id=75be8c2c&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports